module.exports = __webpack_public_path__ + "img/fast_working.6bb303cd.svg";